import { reasonLabel } from "./FeedbackRatingsModal";
import { feedbackRead } from "components/Analytics/feedbackRead";
import React, { useEffect, useState } from "react";
import { Alert, Button, Spinner } from "reactstrap";

const KINDS = [
  { key: "missed", title: "Missed by Comprehend" },
  { key: "madeUp", title: "Made up / wrong" },
  { key: "ptAdded", title: "PT added, never said" },
];
const count = (value) => Number(value || 0).toLocaleString();
const label = (value) => value === "up" ? "Thumbs up" : value === "down" ? "Thumbs down" : reasonLabel(value.replace("reason:", ""));

export default function FeedbackAccuracy({ apiClient, request }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    let active = true;
    setError("");
    setData(null);
    feedbackRead(apiClient, "/v1/notes/feedback/accuracy", request, () => active).then((response) => {
      if (!active) return;
      if (response?.error) throw new Error(response.error);
      if (!Array.isArray(response?.groups)) throw new Error("Accuracy response needs the updated backend.");
      setData(response);
    }).catch(() => { if (active) setError("Unable to load the accuracy check. Try again."); });
    return () => { active = false; };
  }, [apiClient, request, retry]);

  if (error) return <Alert color="danger">{error} <Button size="sm" onClick={() => setRetry(retry + 1)}>Retry</Button></Alert>;
  if (!data) return <div className="fb-loading"><Spinner size="sm" /> Loading the accuracy check…</div>;

  return (
    <div className="note-intel-panel fb-panel fb-compact-panel">
      <div className="note-intel-panel-header"><div>
        <h3>How feedback lines up with note edits</h3>
        <p>Edit tags found on notes with each rating or reported reason.</p>
      </div></div>
      <p className="fb-muted">
        <strong>{count(data.classifiedNotes)} of {count(data.ratedNotes)} rated visits</strong> have edit classifications.
        {" "}{count(data.ratedNotes - data.capturedNotes)} have no signed capture;
        {" "}{count(data.capturedNotes - data.classifiedNotes)} have a capture without edit classifications.
      </p>
      {!data.ratedNotes ? <p className="fb-muted">No rated notes in these filters.</p> :
        <div className="table-responsive"><table className="fb-acc-table">
          <thead><tr><th scope="col">Feedback</th><th scope="col">Classified / rated</th>
            {KINDS.map(k => <th scope="col" key={k.key}>{k.title}</th>)}
          </tr></thead>
          <tbody>{(data.groups || []).map(row => <tr key={row.feedback}>
            <th scope="row">{label(row.feedback)}</th>
            <td title={`${count(row.captured)} have a signed capture`}>{count(row.classified)} / {count(row.rated)}</td>
            {KINDS.map(({ key }) => <td key={key} title={`${count(row.counts[key])} of ${count(row.classified)} classified notes`}>
              {!row.classified ? "—" : row.counts[key] > 0 && row[key] === 0 ? "<0.1%" : `${row[key]}%`}
            </td>)}
          </tr>)}</tbody>
        </table></div>}
      <p className="fb-footnote">
        Percentages use classified notes in each row. 0% means no matching tag; — means no classification is available.
        Notes with very small edits may never be classified. Each visit counts once per row; rows can overlap.
        Matches use the latest signed capture of the visit, not necessarily the rated generation or flagged section.
        These are associations, not confirmation that a complaint was correct.
      </p>
    </div>
  );
}
